import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-instructions',
  templateUrl: './download-instructions.component.html',
  styleUrls: ['./download-instructions.component.css']
})
export class DownloadInstructionsComponent implements OnInit {

  showing = false;

  constructor() { }

  ngOnInit(): void {
  }

  show() {
    this.showing = true;
  }

  close() {
    this.showing = false;
  }

}
